<div class="font-noto">
  <hr class="tw-mt-4" />
  <div id="redirectBtn" class="tw-font-bold tw-text-200 tw-pt-4 tw-px-6 tw-pb-4" (click)="navigateTo('/iframe?src=https://cdn.cureskin.com/refunds-and-cancellations.html')">+ Refund and Return Policy</div>
</div>